export enum TimeUnit {
  Day = "Day",
  Month = "Month",
  Year = "Year",
}
